export default "__VITE_PUBLIC_ASSET__c35d0f1c__"